module.exports = __webpack_public_path__ + "school/img/application.c00af902.png";